module.exports = __webpack_public_path__ + "assets/85a83742196ae66117f1417f03c1f6ba.mp3";